import moment from 'moment';
import React, { useEffect, useState, useRef, useImperativeHandle, forwardRef } from 'react';
import { api } from 'api';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import classNames from 'classnames';
import styles from './right.module.scss';
import { queryFreeBusyList } from '../../service';
import MoreEvent from './MoreEvent';
import { isAlldayOrCrossEvent, sortByUser, transfer } from './util';
import EventCell from './EventCell';
import scheduleTracker from '../../tracker';
import { getIn18Text } from 'api';
import { getWeekDayStr } from '../../util';
const sysApi = api.getSystemApi();
const fixNumber = (num) => `${num < 10 ? '0' : ''}${num}:00`;
const timeLineScale = new Array(24).fill(null).map((_, index) => fixNumber(index + 1));
const timeObjState = new Array(24).fill(false);
const CELL_HEIGHT = 50;
const CELL_WIDTH = 172;
const COL_WIDTH = 60;
const ALL_DAY_EVENTS_NUM = 3;
const TIME_CELL_MARGIN_RIGHT = 5;
const TIME_CELL_MARGIN_LEFT = 2;
const Right = ({ loading, setLoading, user, selectedDay, setSelectedDay, addSchedule }, ref) => {
    const [schedule, setSchedule] = useState([]);
    const scrollRef = useRef(null);
    const [timeClick, setTimeClick] = useState(timeObjState);
    const [scrollFinish, setScrollFinish] = useState(false);
    const [userNameArr, setUserNameArr] = useState(['', '']);
    useEffect(() => {
        loading && getSchedule();
    }, [loading]);
    const resetTimeClick = () => {
        setTimeClick(new Array(24).fill(false));
    };
    useImperativeHandle(ref, () => ({
        resetTimeClick,
    }));
    useEffect(() => {
        setLoading(true);
        updateNow();
        const timer = setInterval(() => {
            updateNow();
        }, 60 * 1000);
        return () => {
            clearInterval(timer);
        };
    }, [selectedDay]);
    useEffect(() => {
        scrollToNow();
    }, []);
    const getSchedule = () => {
        var _a;
        const currentUser = (_a = sysApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
        const users = [...new Set([user, currentUser])];
        setSchedule([]);
        queryFreeBusyList({
            users,
            start: selectedDay.clone().startOf('day').toDate(),
            end: selectedDay.clone().endOf('day').toDate(),
        }).then(res => {
            setLoading(false);
            const sortEvents = sortByUser(res, users);
            const userArr = sortEvents.map(i => { var _a; return (_a = i === null || i === void 0 ? void 0 : i.account) === null || _a === void 0 ? void 0 : _a.extNickname; });
            setSchedule(sortEvents);
            setUserNameArr(userArr);
        });
    };
    const scrollToNow = () => {
        var _a;
        const scrollInstance = (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.osInstance();
        const dayStart = moment().startOf('day');
        let y = moment().diff(dayStart, 'hour', true) * CELL_HEIGHT;
        if (y < 4.5 * CELL_HEIGHT) {
            y = 0;
        }
        else {
            y -= 4.5 * CELL_HEIGHT;
        }
        if (scrollInstance) {
            scrollInstance.scroll({ y }, 100, undefined, () => {
                setScrollFinish(true);
            });
        }
        setTimeout(() => {
            setScrollFinish(true);
        }, 100);
    };
    const updateNow = () => {
        const isToday = selectedDay.isSame(moment(), 'day');
        if (isToday) {
            const dayStart = moment().startOf('day');
            const nowTop = moment().diff(dayStart, 'hour', true) * CELL_HEIGHT;
            setTimeout(() => {
                if (document.getElementById('nowRef')) {
                    document.getElementById('nowRef').style.top = nowTop - 1 + 'px';
                }
                if (document.getElementById('timeRef')) {
                    document.getElementById('timeRef').innerHTML = moment().format('HH:mm');
                }
            }, 0);
            const minute = moment().minute();
            if (minute > 50 || minute < 10) {
                const nearHour = moment().clone();
                nearHour.hour(minute > 50 ? moment().hour() + 1 : moment().hour());
                const timeStr = nearHour.minute(0).format('HH:mm');
                if (document.getElementById(timeStr)) {
                    document.getElementById(timeStr).style.opacity = '0';
                }
            }
            else {
                timeLineScale.forEach(t => {
                    if (document.getElementById(t)) {
                        document.getElementById(t).style.opacity = '1';
                    }
                });
            }
        }
        else {
            timeLineScale.forEach(t => {
                if (document.getElementById(t)) {
                    document.getElementById(t).style.opacity = '1';
                }
            });
        }
    };
    const handleTime = (idx) => {
        const newArr = new Array(24).fill(false);
        newArr[idx] = true;
        setTimeClick(newArr);
        addSchedule(false, idx);
        scheduleTracker.scheduleContact({
            action: 'create',
            type: 'view_zone',
        });
    };
    const renderHeader = () => {
        const weekStr = getWeekDayStr(selectedDay) ? ` ${getWeekDayStr(selectedDay)}` : '';
        const date = selectedDay.format(getIn18Text('NIANYUERI')) + weekStr;
        const next = selectedDay.clone().add(1, 'd');
        const prev = selectedDay.clone().subtract(1, 'd');
        return (React.createElement("div", { className: styles.header },
            React.createElement("button", { onClick: () => {
                    !selectedDay.isSame(moment(), 'day') && setSelectedDay(moment());
                }, type: "button", style: { width: 46 }, className: styles.headerBtn }, getIn18Text('JINTIAN')),
            React.createElement("span", { className: styles.headerTitle }, date),
            React.createElement("button", { onClick: () => {
                    setSelectedDay(prev);
                }, type: "button", style: { width: 28, marginLeft: 16 }, className: styles.headerBtn },
                React.createElement("i", { className: styles.left })),
            React.createElement("button", { onClick: () => {
                    setSelectedDay(next);
                }, type: "button", style: { width: 28, marginLeft: 8 }, className: styles.headerBtn },
                React.createElement("i", { className: styles.right }))));
    };
    const renderMoreAllDayEvent = (events) => (React.createElement(React.Fragment, null,
        events.map((i, idx) => idx < ALL_DAY_EVENTS_NUM - 1 ? (React.createElement("div", { className: styles.eventOuter, key: i.scheduleId },
            React.createElement(EventCell, { event: i }))) : null),
        React.createElement(MoreEvent, { num: ALL_DAY_EVENTS_NUM, events: events })));
    const renderAllDay = (events) => {
        if (!events || !events.length) {
            return null;
        }
        if (events.length <= ALL_DAY_EVENTS_NUM) {
            return events.map(i => (React.createElement("div", { className: styles.eventOuter, key: i.scheduleId },
                React.createElement(EventCell, { event: i }))));
        }
        return renderMoreAllDayEvent(events);
    };
    const renderTableHeader = () => {
        var _a, _b, _c, _d;
        const Arr = schedule.map(i => {
            var _a;
            return ({
                name: (_a = i === null || i === void 0 ? void 0 : i.account) === null || _a === void 0 ? void 0 : _a.extNickname,
                events: i === null || i === void 0 ? void 0 : i.freeBusyItems.filter(e => isAlldayOrCrossEvent(e)),
            });
        });
        return (React.createElement("div", { className: styles.tableHeader },
            React.createElement("div", { className: styles.tableTh, style: { width: COL_WIDTH, justifyContent: 'flex-end' } },
                React.createElement("span", { className: styles.colTh }, getIn18Text('QUANTIAN'))),
            React.createElement("div", { className: styles.tableTh, style: { width: CELL_WIDTH } },
                React.createElement("div", { className: styles.name }, userNameArr[0] || ((_a = Arr[0]) === null || _a === void 0 ? void 0 : _a.name)),
                renderAllDay((_b = Arr[0]) === null || _b === void 0 ? void 0 : _b.events)),
            React.createElement("div", { className: styles.tableTh, style: { width: CELL_WIDTH } },
                React.createElement("div", { className: styles.name }, userNameArr[1] || ((_c = Arr[1]) === null || _c === void 0 ? void 0 : _c.name)),
                renderAllDay((_d = Arr[1]) === null || _d === void 0 ? void 0 : _d.events))));
    };
    const renderTableBody = () => {
        const isToday = selectedDay.isSame(moment(), 'day');
        const dayStart = moment().startOf('day');
        const nowTop = moment().diff(dayStart, 'hour', true) * CELL_HEIGHT;
        return (React.createElement(OverlayScrollbarsComponent, { ref: scrollRef, className: classNames(styles.tableBody, { [styles.tableBodyShow]: scrollFinish }) },
            React.createElement("div", { className: styles.tableBodyIn, style: { height: CELL_HEIGHT * 24 } },
                React.createElement("div", { className: styles.timeOuter, style: { width: COL_WIDTH } }, timeLineScale.map((t, idx) => (React.createElement("div", { className: styles.timeCell, key: t, style: { width: COL_WIDTH, height: CELL_HEIGHT } },
                    React.createElement("span", { id: t, style: { height: idx < 23 ? 20 : 0 }, className: styles.time }, idx < 23 ? t : null))))),
                React.createElement("div", { className: styles.Tbody, style: { width: CELL_WIDTH * 2 } },
                    timeLineScale.map(t => (React.createElement("div", { className: styles.Tr, key: t, style: { width: CELL_WIDTH * 2, height: CELL_HEIGHT } },
                        React.createElement("div", { className: styles.Td, style: { width: CELL_WIDTH + 1, height: CELL_HEIGHT } }),
                        React.createElement("div", { className: styles.Td, style: { width: CELL_WIDTH + 1, height: CELL_HEIGHT } })))),
                    renderAllEvents()),
                isToday && (React.createElement("div", { id: "nowRef", className: styles.now, style: { top: nowTop - 1, width: CELL_WIDTH * 2 } },
                    React.createElement("span", { id: "timeRef", className: styles.timeNow }, moment().format('HH:mm')))))));
    };
    const renderAllEvents = () => {
        let Arr = [];
        if (schedule.length) {
            Arr = schedule.map(i => (i === null || i === void 0 ? void 0 : i.freeBusyItems) || []);
        }
        return (React.createElement("div", { className: styles.timeContent },
            React.createElement("div", { className: styles.timeContentIn, style: { width: CELL_WIDTH - TIME_CELL_MARGIN_RIGHT - TIME_CELL_MARGIN_LEFT, marginRight: TIME_CELL_MARGIN_RIGHT, marginLeft: TIME_CELL_MARGIN_LEFT } }, !!schedule.length && renderEvent(Arr[0])),
            React.createElement("div", { className: styles.timeContentIn, style: { width: CELL_WIDTH - TIME_CELL_MARGIN_RIGHT - TIME_CELL_MARGIN_LEFT, marginRight: TIME_CELL_MARGIN_RIGHT, marginLeft: TIME_CELL_MARGIN_LEFT } },
                timeClick.map((t, idx) => (React.createElement("div", { className: styles.fakeTd, onClick: () => handleTime(idx), key: idx, style: { width: CELL_WIDTH * 2, height: CELL_HEIGHT, marginLeft: -CELL_WIDTH - TIME_CELL_MARGIN_LEFT } }))),
                !!schedule.length && renderEvent(Arr[1]))));
    };
    const renderEvent = (events) => {
        const myEvents = transfer(events, CELL_HEIGHT);
        return (React.createElement(React.Fragment, null, myEvents.map(i => (React.createElement("div", { className: styles.eventTimeOuter, key: i.scheduleId, style: {
                top: i.top,
                left: i.left + '%',
                right: i.right + '%',
                height: i.height,
            } },
            React.createElement(EventCell, { event: i }))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.outer },
            renderHeader(),
            React.createElement("div", { className: styles.table },
                renderTableHeader(),
                renderTableBody()))));
};
export default forwardRef(Right);
